// extracted by mini-css-extract-plugin
export default {"date":"Weather_date__jf+-E","temp":"Weather_temp__GWFPk","weather":"Weather_weather__SkvdM","description":"Weather_description__4Ryyn","wrapper":"Weather_wrapper__O3S+y"};